<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      大运中心站<br>
站点介绍<br>
大运中心站位于黄阁路与龙翔大道交叉口西北侧，沿黄阁路东南-西北向布置。车站周边主要以居住、体育、绿化用地为主。车站东北侧为绿景大公馆、前进村、建新村等居住用地，西北侧为大运中心体育馆、大运中心体育场和大运公园等公共休闲体育用地，西南侧为山体绿化，东南侧规划为商业用地。车站设置有6个出入口，其中B口为主要紧急出入口,C口为备用紧急出入口。田心方向公交接驳口在B口、大运方向公交接驳口在C口，C出入口通道处设置公共卫生间（含第三卫生间）。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:02	23:02	16号线	5分32秒	6分33秒<br>
田心	06:04	23:47	16号线	5分32秒	6分33秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:02	23:02	16号线	5分50秒	6分钟-9分钟<br>
田心	06:06	23:47	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:02	00:02	16号线	5分50秒	6分钟-9分钟<br>
田心	06:06	00:47	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
建新村，星河时代，台中工业区，维也纳国际酒店，城市立方国际儿童中心，金顺创业园，汇合大厦，市政道路在建<br><br>
B出入口:<br>
绿景大公馆，深圳市龙岗区外国语学校，市政道路在建<br><br>
C出入口:<br>
大运中心，市政道路在建<br><br>
D出入口:<br>
大运中心香港中文大学（深圳），市政道路在建<br><br>
E出入口:<br>
深圳信息职业技术学院，华南师范大学附属龙岗大学大运学校，市政道路在建<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 陂头背新村<br>
802、923、E5、M139、M315、M318、M386<br><br>
A2出入口:<br>
公交站名： 陂头背新村<br>
802、923、E5、M139、M315、M318、M386<br><br>
B出入口:<br>
公交站名： 大运中心体育馆<br>
M229、M317、M360、M446<br><br>
C出入口:<br>
公交站名： 大运中心体育馆<br>
M229、M317、M360、M446<br><br>
D出入口:<br>
公交站名： 大运中心<br>
802、E27、E6、M139、M165、M315、M386、M446、M447、国际低碳城论坛接驳专线、高快巴士81号<br><br>
E出入口:<br>
公交站名： 大运中心<br>
802、E27、E6、M139、M165、M315、M386、M446、M447、国际低碳城论坛接驳专线、高快巴士81号<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>